import { createSelector } from "reselect"
import { get, first, chain } from "lodash"
import { getStartDate, getEndDate } from "modules/security-profile/selectors/dates"
import { toIsoDate } from "helpers/dates"
import { createIntradaySelector } from "modules/security-profile/selectors/intraday"

const EMPTY_OBJECT = {}

export const getBetaData = createIntradaySelector(
  "global.data.securityBetaHistory.data.model.simulation.beta",
  "global.data.securityBetaHistory.data.model.intradaySimulation.beta",
  EMPTY_OBJECT,
  EMPTY_OBJECT,
)

function formatBeta(beta) {
  return chain(beta)
    .map(({ date, predicted, historical }) => ({
      date,
      factors: { predicted, historical },
    }))
    .value()
}

export const getBeta = createSelector(
  [getBetaData],
  (absolute) =>
    formatBeta(absolute),
)

export const getFilteredBeta = createSelector(
  [getBeta, getStartDate, getEndDate],
  (beta, startDate, endDate) =>
    beta.filter(data => toIsoDate(data.date) >= startDate && toIsoDate(data.date) <= endDate),
)

export const getFirst = createSelector(
  [getBeta],
  (beta) => first(beta),
)

export const getFirstHistoricalBetaDate = createSelector(
  [getFilteredBeta],
  (beta) => get(first(beta), "date", null),
)
